const MARQUEE_SPEED = 42;

/**
 * @param {HTMLElement} bar
 */
function setTrustBarHeight(bar) {
  const height = bar.offsetHeight;
  document.documentElement.style.setProperty('--malle-trust-bar-height', `${height}px`);

  const section = bar.closest('.malle-trust-bar-section');
  if (section instanceof HTMLElement) {
    section.style.minHeight = `${height}px`;
  }
}

/**
 * @param {HTMLElement} bar
 * @param {number} viewportWidth
 */
function setupTrustMarquee(bar, viewportWidth) {
  const track = bar.querySelector('[data-trust-track]');
  const seedGroup = bar.querySelector('[data-trust-seed]');

  if (!(track instanceof HTMLElement) || !(seedGroup instanceof HTMLElement)) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    track.style.animation = 'none';
    track.replaceChildren(seedGroup.cloneNode(true));
    return;
  }

  const seedMarkup = seedGroup.innerHTML;
  const buildGroup = (markup) => {
    const group = document.createElement('div');
    group.className = 'malle-trust-bar__group';
    group.innerHTML = `<p class="malle-trust-bar__text">${markup}</p>`;
    return group;
  };

  let markup = seedMarkup;
  let probe = buildGroup(markup);
  probe.style.position = 'absolute';
  probe.style.visibility = 'hidden';
  probe.style.pointerEvents = 'none';
  track.appendChild(probe);

  let safety = 0;
  while (probe.offsetWidth < viewportWidth + 80 && safety < 8) {
    markup += seedMarkup;
    probe.innerHTML = `<p class="malle-trust-bar__text">${markup}</p>`;
    safety += 1;
  }

  const loopWidth = probe.offsetWidth;
  probe.remove();

  if (!loopWidth) return;

  const animatedGroup = buildGroup(markup);
  const cloneGroup = buildGroup(markup);
  cloneGroup.setAttribute('aria-hidden', 'true');

  track.replaceChildren(animatedGroup, cloneGroup);

  const duration = loopWidth / MARQUEE_SPEED;
  track.style.setProperty('--marquee-shift', `${loopWidth}px`);
  track.style.animationDuration = `${duration}s`;
  track.style.animationDelay = `-${duration}s`;
}

/**
 * @param {HTMLElement} bar
 */
function initTrustBar(bar) {
  let lastViewportWidth = 0;
  let frameId = 0;

  const update = () => {
    cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(() => {
      setTrustBarHeight(bar);

      const viewport = bar.querySelector('.malle-trust-bar__viewport');
      const viewportWidth = viewport instanceof HTMLElement ? viewport.clientWidth : 0;

      if (!viewportWidth || viewportWidth === lastViewportWidth) return;

      lastViewportWidth = viewportWidth;
      setupTrustMarquee(bar, viewportWidth);
      setTrustBarHeight(bar);
    });
  };

  update();

  window.addEventListener('resize', update, { passive: true });

  if ('ResizeObserver' in window) {
    const viewport = bar.querySelector('.malle-trust-bar__viewport');
    if (viewport instanceof HTMLElement) {
      const observer = new ResizeObserver(update);
      observer.observe(viewport);
    }
  }
}

document.querySelectorAll('[data-malle-trust-bar]').forEach((bar) => {
  if (bar instanceof HTMLElement) initTrustBar(bar);
});
